// material
import {
  Container,
  FormGroup,
  FormControlLabel,
  Switch,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
  Tooltip,
  Checkbox
} from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import { useTranslation } from 'react-i18next';
import * as React from 'react';
import axios from '../../utils/axios';
import { useEffect, useState } from 'react';
import { RootState, useDispatch, useSelector } from '../../redux/store';
import { updateProfile } from '../../redux/slices/user';
import { User } from '../../@types/model/user';
import { Icon } from '@iconify/react';
import { generatePath } from 'react-router';
import { NavLink } from 'react-router-dom';
import { PATH_DASHBOARD } from 'routes/paths';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import LoadingSpinnerTransparent from 'components/LoadingSpinnerTransparent';
import { Device } from '../../@types/model/device';
import { DatePicker } from '@mui/lab';
import dayjs, { Dayjs } from 'dayjs';
import DayjsUtils from '@date-io/dayjs';
import { apiConfig } from '../../config';
import { LoadingButton } from '@mui/lab';
import { MIconButton } from 'components/@material-extend';
import { useSnackbar } from 'notistack';
import closeFill from '@iconify/icons-eva/close-fill';
import downloadFill from '@iconify/icons-eva/download-fill'; // o '@iconify/icons-eva/download' según el icono exacto
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import { checkRoles, ROLE_USER } from 'guards/CheckRoles';
// ----------------------------------------------------------------------

type ReportParams = {
  devices: string;
  fields: string;
  temporal_interval: string;
  type: string;
  u: string | null;
  date: number | undefined;
  s: string | null;
  device: string | null;
};

export default function ReportListRepsol() {
  const [format, setFormat] = useState<string>('excel');
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingDevice, setLoadingDevice] = useState<string>('');
  const [loadingDownloadStock, setLoadingDownloadStock] = useState<boolean>(false);
  const [loadingSend, setLoadingSend] = useState<boolean>(false);
  // const [temporalInterval, setTemporalInterval] = useState<string>('to_now');
  const [shareReportEmail, setShareReportEmail] = useState<string>('');
  // const [trimester, setTrimester] = useState<string>('2022-3');
  const [dateRangeValue, setDateRangeValue] = React.useState<Dayjs | null>(
    dayjs().endOf('week').subtract(1, 'week')
  );
  const [devices, setDevices] = useState<Device[]>([]);
  const [isChecked, setIsChecked] = useState<boolean[]>([]);
  const [isALLChecked, setIsAllChecked] = useState<boolean>(true);
  const [selectedDevices, setSelectedDevices] = useState<Device[]>([]);
  const { themeStretch } = useSettings();
  const { t } = useTranslation();
  const { isLoading } = useSelector((state: RootState) => state.user);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const pageTitle = t('download_reports');
  const applicationDispatch = useDispatch();
  const [dataIncluded, setDataIncluded] = useState<any>({
    identifier: false,
    device_group: false,
    liters_available: true,
    free_space: true,
    last_data: true,
    percent: true,
    remain: true,
    capacity: true
    // available: true,
  });

  const { loaded, user } = useSelector((state: RootState) => state.user);
  const [userConfiguration, setUserConfiguration] = useState<any>(
    user
      ? user.attributes.configuration
      : {
          receive_weekly_report: false,
          receive_monthly_report: false
        }
  );
  const role = checkRoles(user, ROLE_USER) ? '/' : '/end-user';
  useEffect(() => {
    if (user) {
      setUserConfiguration(user.attributes.configuration);
    }
  }, [user]);

  const getReportByParts = (
    url: string,
    finishCallback: () => void,
    finishErrorCallback: () => void,
    devices: Device[] = [],
    params: ReportParams
  ) => {
    if (devices.length > 50) {
      enqueueSnackbar(t('downloading_try_parts'), {
        variant: 'error',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });

      // There is an error downloading the file. Check by parts.
      const deviceGroups = [];
      const groupSize = 50;
      for (let i = 0; i < devices.length; i += groupSize) {
        const group = devices.slice(i, i + groupSize);
        deviceGroups.push(group);
      }

      deviceGroups.forEach((group: Device[], index) => {
        getReport(url, finishCallback, finishErrorCallback, group, {
          devices: group.map((device) => device.guid).join(','),
          fields: params.fields,
          temporal_interval: params.temporal_interval,
          type: params.type,
          u: params.u,
          date: params.date,
          s: params.s,
          device: params.device
        });
      });
    }
  };

  const getReport = (
    url: string,
    finishCallback: () => void,
    finishErrorCallback: () => void,
    devices: Device[] = [],
    params: ReportParams
  ) => {
    if (devices.length > 50) {
      getReportByParts(url, finishCallback, finishErrorCallback, devices, params);
    } else {
      axios({
        url: url,
        method: 'POST',
        responseType: 'blob', // important
        data: params
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'report.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
          finishCallback();
        })
        .catch((exception) => {
          console.log(exception);

          // Si hay un error, intentaremos descargar por partes.
          getReportByParts(url, finishCallback, finishErrorCallback, devices, params);

          setLoadingDownloadStock(false);
          finishErrorCallback();
        });
    }
  };

  useEffect(() => {
    axios
      .get('/api/v2/device', {
        params: {
          offset: 0,
          size: 1000
        }
      })
      .then(({ data }: any) => {
        setIsChecked(new Array(data.data.length).fill(true));
        setDevices(
          data.data.map((item: any) => {
            return item as Device;
          })
        );
      })
      .catch((err) => console.log(err));
  }, []);
  if (!loaded) {
    return null;
  }

  const updateCheckboxState = (checked: boolean, index: number) => {
    const newState = isChecked.map((value, i) => {
      return index === i ? checked : isChecked[i];
    });
    setIsChecked(newState);
  };

  return (
    <Page title={pageTitle}>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading={pageTitle}
          links={[
            { name: t('home'), href: role },
            {
              name: pageTitle,
              href: PATH_DASHBOARD.devices.new
            }
          ]}
        />
        {/* <h2>Placeholder</h2> */}
        <Grid container spacing={2} style={{ marginTop: '10px' }}>
          <Grid item xs={12} sm={12} md={5}>
            <div className="cuadro-redondeado deposits">
              <h3>{t('deposits')}</h3>
              <div className="deposits--selected">
                <FormControlLabel
                  label={
                    <>
                      {' '}
                      {isChecked.filter((val: boolean) => val).length} {t('deposits_selected')}
                    </>
                  }
                  control={
                    <Checkbox
                      className="deposits--icon"
                      checked={isALLChecked}
                      /** @ts-ignore */
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setIsChecked(new Array(devices.length).fill(event.target.checked));
                        selectedDevices.length === 0
                          ? setSelectedDevices(devices)
                          : setSelectedDevices([]);
                        setIsAllChecked(event.target.checked);
                      }}
                    />
                  }
                />
              </div>
              {devices.length > 0 ? (
                <div className="deposits--list">
                  {devices.map((device: Device, index) => {
                    return (
                      <div className="deposits--list--deposit" key={device.attributes.identifier}>
                        <FormControlLabel
                          label={
                            <Tooltip title={device.attributes.name}>
                              <NavLink
                                to={generatePath(PATH_DASHBOARD.end_user.devices.details, {
                                  guid: device.guid
                                })}
                                className="btn-identifier"
                              >
                                {device.attributes.name}
                              </NavLink>
                            </Tooltip>
                          }
                          control={
                            <Checkbox
                              checked={isChecked[index]}
                              /** @ts-ignore */
                              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                updateCheckboxState(event.target.checked, index);
                                if (event?.target.checked) {
                                  setSelectedDevices((selectedDevices) => [
                                    ...selectedDevices,
                                    device
                                  ]);
                                } else {
                                  setSelectedDevices(
                                    selectedDevices.filter(
                                      (item) => item.attributes.name !== device.attributes.name
                                    )
                                  );
                                }
                              }}
                            />
                          }
                        />
                        <div style={{ textAlign: 'right' }}>
                          <span style={{ marginRight: 10 }}>
                            {device.attributes.last_location?.administrative_area_level_2}
                          </span>
                          <LoadingButton
                            loading={loadingDevice === device.guid}
                            variant={'contained'}
                            className="btn-sm"
                            onClick={() => {
                              let url = `${apiConfig.apiBaserl}/api/v2/device/report-measures`;
                              setLoadingDevice(device.guid);
                              getReport(
                                url,
                                () => {
                                  setLoadingDevice('');
                                },
                                () => {
                                  setLoadingDevice('');
                                  enqueueSnackbar(t('Error'), {
                                    variant: 'error',
                                    action: (key) => (
                                      <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                                        <Icon icon={closeFill} />
                                      </MIconButton>
                                    )
                                  });
                                },
                                [],
                                {
                                  devices: '',
                                  fields: '',
                                  temporal_interval: '',
                                  type: 'repsol',
                                  u: user!.id,
                                  date: undefined,
                                  s: '',
                                  device: device.guid
                                }
                              );
                            }}
                          >
                            <Icon icon={downloadFill} />
                          </LoadingButton>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <LoadingSpinnerTransparent />
              )}
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className="cuadro-redondeado">
              <h3>{t('data_included')}</h3>
              <h4>{t('deposit_details')}</h4>
              <FormGroup>
                <FormControlLabel
                  control={<Switch checked={dataIncluded.identifier} />}
                  label={t('identifier')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      identifier: event.target.checked
                    });
                  }}
                />
                <FormControlLabel
                  control={<Switch checked={dataIncluded.device_group} />}
                  label={t('device_group')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      device_group: event.target.checked
                    });
                  }}
                />

                <FormControlLabel
                  control={<Switch checked={dataIncluded.last_data} />}
                  label={t('last_data')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      last_data: event.target.checked
                    });
                  }}
                />
                <FormControlLabel
                  control={<Switch checked={dataIncluded.percent} />}
                  label={t('percent')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      percent: event.target.checked
                    });
                  }}
                />
                <FormControlLabel
                  control={<Switch checked={dataIncluded.remain} />}
                  label={t('remain')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      remain: event.target.checked
                    });
                  }}
                />
                <FormControlLabel
                  control={<Switch checked={dataIncluded.capacity} />}
                  label={t('capacity')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      capacity: event.target.checked
                    });
                  }}
                />
                <FormControlLabel
                  control={<Switch checked={dataIncluded.free_space} />}
                  label={t('free_space')}
                  //disabled
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      free_space: event.target.checked
                    });
                  }}
                />
                {/* <FormControlLabel
                  control={<Switch checked={dataIncluded.gasoil_type} />}
                  label={t('gasoil_type')}
                  disabled
                   @ts-ignore 
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      gasoil_type: event.target.checked
                    });
                  }}
                /> */}
              </FormGroup>
              <h4>{t('charts')}</h4>
              <FormGroup sx={{ mb: 2 }}>
                <FormControlLabel
                  control={<Switch checked={dataIncluded.liters_available} />}
                  label={t('liters_available')}
                  disabled
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setDataIncluded({
                      ...dataIncluded,
                      liters_available: event.target.checked
                    });
                  }}
                />
              </FormGroup>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <div className="cuadro-redondeado cuadro-azul">
              <h3>{t('download_report')}</h3>
              <div style={{ paddingTop: 10, paddingBottom: 20 }}>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="demo-simple-select-label">{t('format')}</InputLabel>
                  <Select
                    style={{ width: '100%' }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={format}
                    label={t('format')}
                    onChange={(event) => {
                      setFormat(event.target.value as string);
                    }}
                    disabled
                  >
                    <MenuItem value={'excel'}>Excel (xlsx)</MenuItem>
                    <MenuItem value={'pdf'}>PDF</MenuItem>
                  </Select>
                </FormControl>
                <LoadingButton
                  loading={loading}
                  variant={'contained'}
                  onClick={() => {
                    let url = `${apiConfig.apiBaserl}/api/v2/device/report`;
                    let list_devices = devices
                      .filter((device, i) => isChecked[i])
                      .map((device) => device.guid)
                      .join(',');
                    let list_fields = Object.keys(dataIncluded)
                      .filter((key) => dataIncluded[key])
                      .join(',');
                    setLoading(true);
                    getReport(
                      url,
                      () => {
                        setLoading(false);
                      },
                      () => {
                        setLoading(false);
                        enqueueSnackbar(t('Error'), {
                          variant: 'error',
                          action: (key) => (
                            <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                              <Icon icon={closeFill} />
                            </MIconButton>
                          )
                        });
                      },
                      devices,
                      {
                        devices: list_devices,
                        fields: list_fields,
                        temporal_interval: 'anual',
                        type: 'repsol',
                        u: user!.id,
                        date: Math.floor(Date.now() / 1000),
                        s: null,
                        device: null
                      }
                    );
                  }}
                >
                  {t('download')}
                </LoadingButton>
              </div>
              <div style={{ paddingTop: 10 }}>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <TextField
                    id="filled-basic"
                    label={t('share_report')}
                    variant={'outlined'}
                    type="email"
                    value={shareReportEmail}
                    onChange={(event) => setShareReportEmail(event.target.value)}
                  />
                </FormControl>

                <LoadingButton
                  loading={loadingSend}
                  variant={'contained'}
                  onClick={() => {
                    let url = `${
                      apiConfig.apiBaserl
                    }/api/v2/device/send-report-to-email?type=weekly&u=${
                      user!.id
                    }&s=&date=${dateRangeValue?.unix()}`;
                    let list_devices = devices
                      .filter((device, i) => isChecked[i])
                      .map((device) => device.guid)
                      .join(',');
                    url += `&devices=` + list_devices;
                    let list_fields = Object.keys(dataIncluded)
                      .filter((key) => dataIncluded[key])
                      .join(',');
                    url += `&fields=` + list_fields;
                    url += `&temporal_interval=anual`;
                    url += `&type=repsol`;
                    url += `&email=` + shareReportEmail;
                    setLoadingSend(true);
                    axios({
                      url: url,
                      method: 'GET'
                    })
                      .then((response) => {
                        setLoadingSend(false);
                        enqueueSnackbar(t('report_sended_correctly'), {
                          variant: 'success',
                          action: (key) => (
                            <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                              <Icon icon={closeFill} />
                            </MIconButton>
                          )
                        });
                      })
                      .catch((exception) => {
                        console.log(exception);
                      });
                  }}
                >
                  {t('send')}
                </LoadingButton>
              </div>
            </div>
          </Grid>
        </Grid>
        {/* <h2>Placeholder</h2> */}
        <Grid container spacing={2} style={{ marginTop: '10px', alignItems: 'stretch' }}>
          <Grid item xs={12} sm={12} md={5} style={{ height: '100%' }}>
            <div className="cuadro-redondeado cuadro-estado-del-deposito">
              <h3 style={{ color: ' #8b8b8b' }}>{t('auto_reports')}</h3>
              <FormGroup>
                <FormControlLabel
                  disabled
                  control={<Switch checked={userConfiguration.receive_weekly_report} />}
                  label={t('receive.weekly_reports')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setUserConfiguration({
                      ...userConfiguration,
                      receive_weekly_report: event.target.checked
                    });
                  }}
                />
                <FormControlLabel
                  disabled
                  control={<Switch checked={userConfiguration.receive_monthly_report} />}
                  label={t('receive.monthly_reports')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setUserConfiguration({
                      ...userConfiguration,
                      receive_monthly_report: event.target.checked
                    });
                  }}
                />
                <FormControlLabel
                  disabled
                  control={<Switch checked={userConfiguration.receive_daily_report} />}
                  label={t('receive.daily_reports')}
                  /** @ts-ignore */
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setUserConfiguration({
                      ...userConfiguration,
                      receive_daily_report: event.target.checked
                    });
                  }}
                />
                <LoadingButton
                  disabled
                  sx={{ maxWidth: '100px', marginTop: '30px' }}
                  variant={'contained'}
                  loading={isLoading}
                  onClick={() => {
                    applicationDispatch(
                      updateProfile({
                        id: user!.id,
                        attributes: {
                          ...user!.attributes,
                          configuration: userConfiguration
                        }
                      } as User)
                    );
                  }}
                >
                  {t('update')}
                </LoadingButton>
              </FormGroup>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className="cuadro-redondeado">
              <h3>{t('stock_history')}</h3>
              <div style={{ paddingTop: 10 }}>
                <FormControl sx={{ mt: 2 }} fullWidth>
                  <LocalizationProvider
                    dateAdapter={DayjsUtils}
                    locale={navigator.language.split('-')[0]}
                  >
                    <DatePicker
                      label={t('start_date')}
                      value={dateRangeValue}
                      onChange={(newValue) => setDateRangeValue(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
                <LoadingButton
                  sx={{ maxWidth: '100px', marginTop: '30px' }}
                  variant={'contained'}
                  loading={loadingDownloadStock}
                  onClick={() => {
                    let url = `${apiConfig.apiBaserl}/api/v2/device/report`;
                    let list_devices = devices
                      .filter((device, i) => isChecked[i])
                      .map((device) => device.guid)
                      .join(',');
                    setLoadingDownloadStock(true);
                    getReport(
                      url,
                      () => {
                        setLoadingDownloadStock(false);
                      },
                      () => {
                        setLoadingDownloadStock(false);
                        enqueueSnackbar(t('Error'), {
                          variant: 'error',
                          action: (key) => (
                            <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                              <Icon icon={closeFill} />
                            </MIconButton>
                          )
                        });
                      },
                      devices,
                      {
                        devices: list_devices,
                        fields: 'free_space,remain,percent,last_data',
                        temporal_interval: 'anual',
                        type: 'repsol',
                        u: user!.id,
                        date: dateRangeValue?.unix(),
                        s: '',
                        device: null
                      }
                    );
                  }}
                >
                  {t('download')}
                </LoadingButton>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
